import ILocation from '../models/ILocation';
import AbstractCRUDService from './AbstractCRUDService';

class LocationService extends AbstractCRUDService<ILocation> {}

export default new LocationService('inquiring/location');
